import { EnumBuilder, type ZodInfer } from '@mntn-dev/utility-types'

export const [PriceContexts, PriceContextSchema] = EnumBuilder(
  'agency',
  'brand'
)
export type PriceContext = ZodInfer<typeof PriceContextSchema>
